import React from "react"
import Cleave from 'cleave.js/react'

class FormattedInput extends React.Component {
  
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Cleave 
        options={this.props.options}
        data-id={this.props.dataId}
        className={this.props.className} 
        type={this.props.type} 
        name={this.props.name} 
        value={this.props.value} 
        placeholder={this.props.placeholder}
        onBlur={this.props.onBlur}
        onFocus={this.props.onFocus}
        onChange={this.props.onChange} />
    )
  }

};

export default FormattedInput